import React from 'react';
import { useNavigate } from 'react-router-dom';

const ArticleCard = ({ title, link }) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col gap-10 p-6 bg-gray-50 dark:bg-grayButton border border-gray-300 dark:border-grayButtonBorder rounded-lg cursor-pointer shadow-sm hover:shadow-lg transition-transform transform hover:-translate-y-1 w-full min-h-12 flex items-left gap-2"
      onClick={() => navigate(link)}
    >

      {/* Título */}
      <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 m-0">{title}</h3>
    </div>
  );
};

export default ArticleCard;
